var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MediaAttachmentsPreview',{staticClass:"event-details-attachments",attrs:{"parent":_vm.parentTypes.CALENDAR,"attachments":_vm.attachments},on:{"openDocumentDrawer":_vm.emitOpen}})}
var staticRenderFns = []

export { render, staticRenderFns }